import { JSX, ReactNode } from 'react'

import { Group, List } from '~/components/component-library'
import { ListItemProps } from '~/components/component-library/List/types'
import { DecodedCalldata } from '~/components/txn-display/calls/DecodedCalldata'
import { DecodedCallSummary } from '~/components/txn-display/state-change/types'

type ContractCallSectionProps = {
  items: ListItemProps[]
  decodedCalls?: DecodedCallSummary[]
  isShowingCalls: boolean
  secondaryDisplayButtons: JSX.Element
  label?: string
  footer?: string | JSX.Element
}

export function ContractCallSection({
  items,
  decodedCalls,
  isShowingCalls,
  secondaryDisplayButtons,
  label = 'Contract call',
  footer,
}: ContractCallSectionProps): ReactNode {
  const showDecodedCalls = isShowingCalls && !!decodedCalls?.length

  return (
    <Group
      label={label}
      secondaryDisplay={secondaryDisplayButtons}
      footer={footer}
    >
      {showDecodedCalls ? (
        <DecodedCalldata calls={decodedCalls} />
      ) : (
        <List items={items} emptyListText="No contract calls found" />
      )}
    </Group>
  )
}
